<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="110px" :model="form">
      <el-form-item label="企业员工">
        <!-- <el-tag v-if="form.corp_userid!=''" style="margin-right:10px">{{ worker_name ? worker_name : '' }} ({{ form.corp_userid }}) </el-tag> -->
        <el-tag v-for="items,index in form.corp_userid" :key="index" style="margin-right:10px" closable @close="handleClose(index)">{{ items.name }} </el-tag>
        <el-button type="primary" size="mini" @click="chorwe">选择企业员工</el-button>
      </el-form-item>
      <el-form-item label="手机号">
        <!-- <el-tag v-if="form.corp_userid!=''" style="margin-right:10px">{{ worker_name ? worker_name : '' }} ({{ form.corp_userid }}) </el-tag> -->
        <el-input v-model="form.phone" placeholder="请输入手机号" style="width: 300px;" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbitr">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import bandstaff from './bandstaff.vue'
import { bindFeiShuKf } from '@/api/officialaccount.js'
export default {
  components: { bandstaff },
  data() {
    return {
      form: {
        corp_userid: [],
        corp_id: '',
        phone: ''
      },
      dialogVisibler: false,
      arr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(corp_id) {
      this.form.corp_id = corp_id
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.form.corp_id, this.form.corp_userid)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.form.corp_userid = arr
      console.log(arr)
    },
    handleClose(index) {
      this.form.corp_userid.splice(index, 1)
    },
    async sumbitr() {
      if (this.form.corp_userid.length === 0) {
        this.$message({
          message: '请选择企业员工',
          type: 'error'
        })
        return
      }
      const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!reg_tel.test(this.form.phone)) {
        this.$message.error('请填写正确的电话')
        return
      }
      this.arr = []
      console.log('this.form.corp_userid', this.form.corp_userid)
      this.arr = this.form.corp_userid.map((item) => {
        return item.employee_no
      })
      const data = await bindFeiShuKf({
        phone: this.form.phone,
        employee_nos: this.arr
      })
      this.$emit('feiupdata')
      console.log('data', data)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
